import { Component } from '@angular/core';

@Component({
  selector: 'sia-ai-chat-full',
  imports: [],
  templateUrl: './ai-chat-full.component.html',
  styleUrl: './ai-chat-full.component.scss'
})
export class AiChatFullComponent {

}
